import { cx } from '@twind/core';
import { AnimatePresence, motion } from 'framer-motion';

import { Title } from '../../../../../components/Typography';
import { ChatFormItem } from '../../../../../services/chatBot';

const itemVariants = {
  visible: (custom: number) => ({
    x: 0,
    opacity: 1,
    transition: {
      delay: custom * 0.1,
      x: { stiffness: 500, velocity: -100 },
    },
  }),
  hidden: (custom: number) => ({
    x: 200,
    opacity: 0,
    transition: {
      delay: custom * 0.05,
      x: { stiffness: 500 },
    },
  }),
};

export default function FormChatItemSingleChoice({
  selected,
  formItem,
  onClickAnswerChoice,
  shouldAnimate,
}: {
  selected: string | null;
  formItem: ChatFormItem;
  onClickAnswerChoice: (choice: string) => void;
  shouldAnimate?: boolean;
}) {
  const renderChoice = (choice: string) => (
    <Title
      onClick={onClickAnswerChoice.bind(null, choice)}
      component="button"
      value={choice}
      className={cx(
        'ostro-chatbot-message-form-choice',
        '~(py-3 px-5 mb-3 rounded-xl block w-full text-left)',
        selected === choice
          ? 'bg-virtualAssistant-selectedOptionBackgroundColor'
          : 'bg-virtualAssistant-optionBackgroundColor'
      )}
    >
      <span dangerouslySetInnerHTML={{ __html: choice }} />
    </Title>
  );

  return (
    <div className="ostro-chatbot-message-form-choice-container">
      {shouldAnimate ? (
        <AnimatePresence key={formItem.ref_id}>
          {formItem.choices.map((choice) => {
            if (!selected || selected === choice) {
              return (
                <motion.div
                  key={choice + formItem.ref_id}
                  variants={itemVariants}
                  whileHover={selected ? {} : { scale: 1.05 }}
                  whileTap={selected ? {} : { scale: 0.95 }}
                  initial="hidden"
                  animate="visible"
                  custom={formItem.choices.indexOf(choice)}
                >
                  {renderChoice(choice)}
                </motion.div>
              );
            }
          })}
        </AnimatePresence>
      ) : (
        <>
          {formItem.choices.map((choice) => {
            if (!selected || selected === choice) {
              return <div key={choice + formItem.ref_id}>{renderChoice(choice)}</div>;
            }
          })}
        </>
      )}
    </div>
  );
}
